import { ControlPointsForm } from '@App/app/entities/forms/at-setup-tab-form.model';
import { AtSetupControlPointsService } from './at-setup-control-points/services/at-setup-control-points-service/at-setup-control-points.service';
import { ControlPoint } from './models/control-point.model';

/**
 * Parses a control-points CSV. The header row is skipped and the trailing line is
 * ignored (the file ends with a newline), matching the export format.
 */
export const parseControlPointsCsv = (csv: string): ControlPoint[] => {
  const controlPoints: ControlPoint[] = [];
  const rows = csv.split('\n');
  for (let index = 1; index < rows.length - 1; index++) {
    const [name, lat, long, alt] = rows[index].split(',');
    controlPoints.push({ name, lat: +lat, long: +long, alt: +alt });
  }
  return controlPoints;
};

/** Builds the GCP control-point settings payload from the current control-points form. */
export const buildControlPointSettings = (
  service: AtSetupControlPointsService,
): ControlPointsForm['value'] => {
  const controlPoints = service.getControlPoints();
  const controlPointsWithMeasurements = service.createHttpControlPoints(controlPoints);
  return {
    ...service.form.getRawValue(),
    controlPoints: controlPointsWithMeasurements,
  };
};
